import type {
  SearchForFacetValuesQueryParams,
  SearchOptions,
  SearchResponse,
} from '@algolia/client-search'
import { defineStore } from 'pinia'
import { ref } from '#imports'

export const useAlgoliaSearchStore = defineStore('algoliaSearch', () => {
  const indexKey = ref(null)
  const indexName = ref(null)
  const results = ref<SearchResponse | null>(null)
  const facetsResults = ref<SearchResponse[]>([])
  const initialFilters = ref('')
  const hitsPerPage = ref<number | null>(null)
  const aroundLatLng = ref<string | null>(null)
  const navigatorGeolocation = ref<GeolocationPosition | null>(null)
  const loadingNavigatorGeolocation = ref(false)
  const availableFacets = ref<string[]>([])
  const availableNumericFilters = ref<string[]>([])
  const searchParameters = ref<SearchForFacetValuesQueryParams & SearchOptions>()
  const activeFacets = ref<string[][]>([])

  function facetResults(facetName: string) {
    return (
      facetsResults.value.find((facetResults) => !!facetResults.facets?.[facetName])?.facets?.[
        facetName
      ] ??
      results.value?.facets?.[facetName] ??
      {}
    )
  }

  function reset() {
    indexKey.value = null
    indexName.value = null
    results.value = null
    facetsResults.value = []
    hitsPerPage.value = null
    aroundLatLng.value = null
  }

  return {
    indexKey,
    indexName,
    results,
    facetsResults,
    initialFilters,
    hitsPerPage,
    aroundLatLng,
    navigatorGeolocation,
    loadingNavigatorGeolocation,
    availableFacets,
    availableNumericFilters,
    searchParameters,
    activeFacets,
    facetResults,
    reset,
  }
})
